import { Button, Icon, Illustration, Typography } from '@saviynt/design-system';
import { useNavigate } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import './NoPolicyState.css';

/**
 * NoPolicyState - Empty state component displayed when no policies exist.
 *
 * Renders an illustration, heading, descriptive text, and a "Create Policy"
 * button that navigates to the policy creation form (`/policies/new`).
 *
 * @returns {JSX.Element} The empty state UI for the policies page.
 *
 * @example
 * ```tsx
 * <NoPolicyState />
 * ```
 */

export default function NoPolicyState() {
  const navigate = useNavigate();
  return (
    <div className='NoPolicyState'>
      <Illustration kind='Empty' className='Example-Illustration' />
      <div className='NoPolicyState-text'>
        <Typography kind='h1' desktop='h1-d' mobile='h1-d'>
          <FormattedMessage
            defaultMessage='No Rules yet'
            id='Ixo+OX'
            description='Message shown when there are no policies'
          />
        </Typography>
        <Typography kind='body1' desktop='body1-d' mobile='body1-d'>
          <FormattedMessage
            defaultMessage="Rules help you automate agent governance: automatically assigning owners, to keep your agents compliant as they're registered or updated. Create your first rule now."
            id='nb+hB8'
            description='Message shown when there are no policies'
          />
        </Typography>
      </div>
      <Button
        kind='filled'
        size='large'
        leftIcon={<Icon kind='Add' />}
        onClick={() => navigate({ to: '/policies/new' })}>
        <FormattedMessage
          defaultMessage='Create Rule'
          id='LsYzrk'
          description='Button to create a new policy'
        />
      </Button>
    </div>
  );
}
